<template>
  <div>
    <a-modal
      :title="title"
      :width="400"
      :visible="visible"
      @cancel="handleCancel"
      @ok="handleOk"
      >
      <div class="detail-wrap" v-if="dataSource1[0].taskType === '1'">
        <div><span class="detail-title">任务名称：</span>{{dataSource1[0].taskName}}</div>
        <div><span class="detail-title">巡查机位置：</span>{{dataSource1[0].inspectionSeat}}</div>
        <div><span class="detail-title">姓名：</span>{{dataSource1[0].workerName}}</div>
        <div><span class="detail-title">片数：</span>{{dataSource1[0].inspectionPiece}}</div>
        <div><span class="detail-title">不良片数：</span>{{dataSource1[0].badPiece}}</div>
        <div>
          <span class="detail-title">不良片数：</span>
          <div class="img-wrap">
            <img v-for="(imgItem,index) in dataSource1[0].qualityInspectionPictureList" preview="0" :key="'quality' + index" :src="imgItem"/>
          </div>
        </div>
      </div>
      <div class="detail-wrap" v-if="dataSource1[0].taskType === '2.1' || dataSource1[0].taskType === '2.2'">
        <div><span class="detail-title">任务名称：</span>{{dataSource1[0].taskName}}</div>
        <div><span class="detail-title">巡查区域：</span>{{dataSource1[0].inspectionArea}}</div>
        <div><span class="detail-title">查核问题：</span>{{dataSource1[0].remark}}</div>
        <div>
          <span class="detail-title">图片上传：</span>
          <div class="img-wrap">
            <img v-for="(imgItem,index) in dataSource1[0].safeFivesInspectionPictureList" preview="0" :key="'safeFives' + index" :src="imgItem"/>
          </div>
        </div>
      </div>
      <div class="detail-wrap" v-if="dataSource1[0].taskType === '3.1' || dataSource1[0].taskType === '3.2'">
        <div><span class="detail-title">任务名称：</span>{{dataSource1[0].taskName}}</div>
        <div>
          <span class="detail-title">图片上传：</span>
          <div class="img-wrap">
            <img v-for="(imgItem,index) in dataSource1[0].safeFivesImprovementPictureList" preview="0" :key="'Fives' + index" :src="imgItem"/>
          </div>
        </div>
      </div>
      <div class="detail-wrap" v-if="dataSource1[0].taskType === '4'">
        <div><span class="detail-title">任务名称：</span>{{dataSource1[0].normNum}}</div>
        <div><span class="detail-title">标准产能置：</span>{{dataSource1[0].realNum}}</div>
        <div><span class="detail-title">实际产能：</span>{{dataSource1[0].workerName}}</div>
        <div><span class="detail-title">达成率：</span>{{dataSource1[0].yieldRate}}</div>
        <div><span class="detail-title">备注：</span>{{dataSource1[0].remark}}</div>
      </div>
      <div class="detail-wrap" v-if="dataSource1[0].taskType === '5'">
        <div><span class="detail-title">任务名称：</span>{{dataSource1[0].taskName}}</div>
        <div>
          <span class="detail-title">图片上传：</span>
          <div class="img-wrap">
            <img v-for="(imgItem,index) in dataSource1[0].daySalaryCheckPictureList" preview="0" :key="'daySalary' + index" :src="imgItem"/>
          </div>
        </div>
      </div>
      <div class="detail-wrap" v-if="dataSource1[0].taskType === '6'">
        <div><span class="detail-title">任务名称：</span>{{dataSource1[0].taskName}}</div>
        <div><span class="detail-title">备注：</span>{{dataSource1[0].remark}}</div>
      </div>
      <div class="detail-wrap" v-if="dataSource1[0].taskType === '7'">
        <div><span class="detail-title">任务名称：</span>{{dataSource1[0].taskName}}</div>
        <div><span class="detail-title">品质达标率：</span>{{dataSource1[0].qualityRate}}</div>
        <div><span class="detail-title">周期达标率：</span>{{dataSource1[0].cycleRate}}</div>
        <div><span class="detail-title">人数达标率：</span>{{dataSource1[0].humanEffectRate}}</div>
        <div><span class="detail-title">5S达标情况：</span>{{dataSource1[0].points5s}}</div>
        <div>
          <span class="detail-title">设备保养：</span>
          <div class="img-wrap">
            <img v-for="(imgItem,index) in dataSource1[0].devicesCarePictureList" preview="6" :key="'device' + index" :src="imgItem"/>
          </div>
        </div>
        <div>
          <span class="detail-title">员工访谈：</span>
          <div class="img-wrap">
            <img v-for="(imgItem,index) in dataSource1[0].employeeInterviewPictureList" preview="6" :key="'employee' + index" :src="imgItem"/>
          </div>
        </div>
        <div>
          <span class="detail-title">员工评优：</span>
          <div class="img-wrap">
            <img v-for="(imgItem,index) in dataSource1[0].staffEvaluationPictureList" preview="6" :key="'staff' + index" :src="imgItem"/>
          </div>
        </div>
        <div>
          <span class="detail-title">大扫除：</span>
          <div class="img-wrap">
            <img v-for="(imgItem,index) in dataSource1[0].cleanUpPictureList" preview="6" :key="'cleanUp' + index" :src="imgItem"/>
          </div>
        </div>
      </div>
      <!-- 查询区域 -->
      <!-- <div class="table-page-search-wrapper">
        <a-form layout="inline"
          @keyup.enter.native="searchQuery">
          <a-row :gutter="24"
            type="flex">
            <a-col :span="8">
              <a-form-item label="用户名称">
                <j-input placeholder="输入用户名称模糊查询"
                  v-model="queryParam.realname"></j-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="用户账号">
                <j-input placeholder="输入用户账号模糊查询"
                  v-model="queryParam.username"></j-input>
              </a-form-item>
            </a-col>
            
            <a-col :span="8">
              <a-form-item label="部门">
                <a-input placeholder="请输入部门"
                  v-model="queryParam.departName"></a-input>
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <span style="float: left;overflow: hidden;"
                class="table-page-search-submitButtons">
                <a-button type="primary"
                  @click="searchQuery"
                  icon="search">查询</a-button>
                <a-button type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px">重置</a-button>
              </span>
            </a-col>

          </a-row>
        </a-form>
      </div> -->
      <!-- table区域-begin -->
      <!-- <div>
        <a-spin :spinning="loadingTable">
          <a-table size="small"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource1"
            :loading="loading"
            :scroll="{ y: 240 }">
          </a-table>
        </a-spin>
      </div> -->
      <!-- table区域-end -->

    </a-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getAction } from '@/api/manage'
import JInput from '@/components/jeecg/JInput'
export default {
  name: "TableMonitorDetail",
  components: {
   JInput
  },
  props:['recordChoose'],
  data () {
    return {
      title: "班组任务详情",
      names: [],
      visible: false,
      placement: 'right',
      description: '',
      // 查询条件
      queryParam: {},
      // 表头
      columns: [ ],
      columns1: [ //品质巡查
        {
          title: '任务名称',
          align: "center",
          width: 200,
          dataIndex: 'taskName'
        },
        {
          title: '巡查机位置',
          align: "center",
          width: 100,
          dataIndex: 'inspectionSeat'
        },
        {
          title: '主手机姓名',
          align: "center",
          width: 100,
          dataIndex: 'principalName'
        },
        {
          title: '巡查片数',
          align: "center",
          width: 100,
          dataIndex: 'inspectionPiece'
        },
        {
          title: '不良片数',
          align: "center",
          width: 100,
          dataIndex: 'badPiece'
        },
        {
          title: '图片',
          align: "center",
          width: 150,
          dataIndex: 'orgCode'
        },
      ],
      columns2: [ //安全5S巡查
        {
          title: '任务名称',
          align: "center",
          width: 200,
          dataIndex: 'taskName'
        },
        {
          title: '巡查区域',
          align: "center",
          dataIndex: 'inspectionArea',
        },
        {
          title: '查核问题',
          align: "center",
          dataIndex: 'remark',
        },
        {
          title: '图片',
          align: "center",
          width: 150,
          dataIndex: 'orgCode'
        },
      ],
      columns3: [ //安全5S改善
        {
          title: '任务名称',
          align: "center",
          width: 200,
          dataIndex: 'taskName'
        },
        {
          title: '巡查类型',
          align: "center",
          dataIndex: 'taskType_dictText',
        },
        {
          title: '图片',
          align: "center",
          width: 150,
          dataIndex: 'orgCode'
        },
      ],
      columns4: [ //生产进度管理
        {
          title: '任务名称',
          align: "center",
          width: 200,
          dataIndex: 'taskName'
        },
        {
          title: '标准产能',
          align: "center",
          dataIndex: 'normNum',
        },
        {
          title: '实际产能',
          align: "center",
          dataIndex: 'realNum',
        },
        {
          title: '达成率',
          align: "center",
          dataIndex: 'yieldRate',
        },
        {
          title: '备注',
          align: "center",
          width: 150,
          dataIndex: 'remark'
        },
      ],
      columns5: [ //日薪核对
        {
          title: '任务名称',
          align: "center",
          width: 200,
          dataIndex: 'taskName'
        },
        {
          title: '图片',
          align: "center",
          width: 150,
          dataIndex: 'orgCode'
        },
      ],
      columns6: [ //工作总结
        {
          title: '任务名称',
          align: "center",
          width: 200,
          dataIndex: 'taskName'
        },
        {
          title: '备注',
          align: "center",
          width: 150,
          dataIndex: 'remark'
        },
      ],
      columns7: [ //周工作总结
        {
          title: '任务名称',
          align: "center",
          width: 200,
          dataIndex: 'taskName'
        },
        {
          title: '品质达标率',
          align: "center",
          width: 150,
          dataIndex: 'qualityRate'
        },
        {
          title: '周期达标率',
          align: "center",
          width: 150,
          dataIndex: 'cycleRate'
        },
        {
          title: '人数达标率',
          align: "center",
          width: 150,
          dataIndex: 'humanEffectRate'
        },
        {
          title: '5S积分状况',
          align: "center",
          width: 150,
          dataIndex: 'points5s'
        },
        {
          title: '图片',
          align: "center",
          width: 150,
          dataIndex: 'nicai'
        },
      ],
      //数据集
      dataSource1: [],
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      url: {
        list: "/sys/user/list",
      },
      loadingTable:false,
    }
  },
  methods: {
    handleCancel () {
      this.visible = false;
    },
    handleOk () {
      this.visible = false;
    },
    add (recordChoose) {
      this.visible = true;
      this.dataSource1 = recordChoose
      this.$previewRefresh()
      // switch(recordChoose[0].taskType){
      //   case '1':
      //     this.columns = this.columns1
      //     break
      //   case '2.1':
      //     this.columns = this.columns2
      //     break
      //   case '2.2':
      //     this.columns = this.columns2
      //     break
      //   case '3.1':
      //     this.columns = this.columns3
      //     break
      //   case '3.2':
      //     this.columns = this.columns3
      //     break
      //   case '4':
      //     this.columns = this.columns4
      //     break
      //   case '5':
      //     this.columns = this.columns5
      //     break
      //   case '6':
      //     this.columns = this.columns6
      //     break
      //   case '7':
      //     this.columns = this.columns7
      //     break
      // }
    },
  }
}
</script>
<style lang="less" scoped>
.ant-card-body .table-operator {
  margin-bottom: 18px;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 15px;
  padding-bottom: 15px;
}

.anty-row-operator button {
  margin: 0 5px;
}

.ant-btn-danger {
  background-color: #ffffff;
}

.ant-modal-cust-warp {
  height: 100%;
}

.ant-modal-cust-warp .ant-modal-body {
  height: calc(100% - 110px) !important;
  overflow-y: auto;
}

.ant-modal-cust-warp .ant-modal-content {
  height: 90% !important;
  overflow-y: hidden;
}
.detail-wrap {
  font-size: 15px;
}
.detail-wrap > div {
  margin-bottom: 10px;
}
.detail-wrap .detail-title {
  display:inline-block;
  font-weight: bold
}
.img-wrap {
  display: flex;
}
.img-wrap > img {
  width: 50px;
  height: 50px;
  margin: 10px 10px 0 0;
}
</style>